import { render, staticRenderFns } from "./company_profile.vue?vue&type=template&id=53c7e829"
import script from "./company_profile.vue?vue&type=script&lang=js"
export * from "./company_profile.vue?vue&type=script&lang=js"
import style0 from "./company_profile.vue?vue&type=style&index=0&id=53c7e829&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports